import { readFeatureFlagFromDocumentCookie } from './read-feature-flag';

/**
 * Keeps the search results page mounted (hidden, under React's <Activity>) after a client-side
 * navigation away from it, so browser Back to that same search reveals it instantly with its
 * state and scroll position intact instead of re-fetching and re-rendering it. Client-only: SSR
 * output is unchanged either way. See utils/navigation/srp-keep-alive.tsx. Off by default while
 * it's dark-launched; managed from /backoffice/experiments (feature-flag-registry.ts).
 */
export const SRP_KEEP_ALIVE_COOKIE = 'dev_enable_srp_keep_alive';

export function isSrpKeepAliveEnabled(): boolean {
  if (typeof document === 'undefined') return false;
  return readFeatureFlagFromDocumentCookie(SRP_KEEP_ALIVE_COOKIE, false);
}
